import { theme } from '../../constants/defaults';
import { formatMoney } from '../../utils/product';

export default function(totalCartPrice) {
  const freeShippingBarEls = document.querySelectorAll('.js-free-shipping-bar');
  const freeShippingTextEls = document.querySelectorAll('.js-free-shipping-text');
  const amountNeededEls = document.querySelectorAll('.js-amount-needed');

  if (totalCartPrice < 150) {
    freeShippingTextEls.forEach(freeShippingTextEl => {
      const amountNeededInCents = (150 - totalCartPrice) * 100; // convert to cents
      freeShippingTextEl.innerHTML = `${theme.strings.cart_spend} <strong>${formatMoney(
        amountNeededInCents,
      )}</strong> ${theme.strings.cart_required}`;
    });

    amountNeededEls.forEach(amountNeededEl => {
      amountNeededEl.innerHTML = 60 - totalCartPrice;
    });

    freeShippingBarEls.forEach(freeShippingBarEl => {
      freeShippingBarEl.classList.remove('hide');
    });
  } else if (totalCartPrice >= 150) {
    freeShippingBarEls.forEach(freeShippingBarEl => {
      freeShippingBarEl.classList.remove('hide');
    });
    freeShippingTextEls.forEach(freeShippingTextEl => {
      freeShippingTextEl.innerHTML = theme.strings.cart_achieved;
    });
  }
}
